import { toMoney, toDurationStr } from 'utils/number';
import userService from 'services/data/user';

export const VideoHoursPerBlock = 10;
const VideoPricePerBlock = 5;
const PricePerClearinghouse = 15;
const PricePerPrescriber = 40;
const PricePerControlled = 9;

export const RepugenPackageOptions = [
  { name: 'RepuGen Core Plan', value: 'core', price: 57 },
  { name: 'RepuGen Core + Marketing Solutions', value: 'advanced', price: 87 }
];

export function getSubscriptionAmount(number, type, isAnnual) {
  const amountPerType = type === 'standard' ? 27 : 47;
  return number * amountPerType * (isAnnual ? 10 : 1);
}

export function getSubscriptionText(number, type, isAnnual) {
  const amount = getSubscriptionAmount(number, type, isAnnual);
  return `${number} x ${type === 'standard' ? 'Standard' : 'Virtual Practice'} ${isAnnual ? 'Annual' : 'Monthly'} (${toMoney(amount, '$')} per ${isAnnual ? 'year' : 'month'})`;
}

export function getDedicatedNumbersPricing(phoneNumberPrice, isAnnual) {
  return `${toMoney(phoneNumberPrice * (isAnnual ? 12 : 1), '$')} per ${isAnnual ? 'year' : 'month'}`;
}

export function getRepugenPricing(repuPackage, number, isAnnual) {
  const opt = RepugenPackageOptions.find(pp => pp.value === repuPackage);
  if (opt == null || !number) { return null; }
  const total = opt.price * number * (isAnnual ? 12 : 1);
  return `${number} x ${opt.name} ${isAnnual ? 'Annual' : 'Monthly'} (${toMoney(total, '$')} per ${isAnnual ? 'year' : 'month'})`;
}

export function getVideoBlocksPricing(number, isAnnual, hideAvailable) {
  const hours = number * VideoHoursPerBlock;
  const total = VideoPricePerBlock * number * (isAnnual ? 12 : 1);
  const res = `${hours} hours (${toMoney(total, '$')} per ${isAnnual ? 'year' : 'month'})`;
  if (hideAvailable || hours === 0) { return res; }
  const available = userService.videoStats.value?.available;
  if (available == null) { return res; }
  return `${res} - ${toDurationStr(available)} available`;
}

export function getClearinghousePricing(number, isAnnual) {
  const total = PricePerClearinghouse * number * (isAnnual ? 12 : 1);
  return `${number} Bill Provider Tax ID${number === 1 ? '' : 's'} (${toMoney(total, '$')} per ${isAnnual ? 'year' : 'month'})`;
}

export function getErxPricing(numPrescribers, numRestricted, isAnnual) {
  const total = (numPrescribers * PricePerPrescriber) + (numRestricted * PricePerControlled);
  const totalCost = toMoney(total * (isAnnual ? 12 : 1), '$');
  return `${numPrescribers} Prescriber${(numPrescribers === 1 ? '' : 's')}, ${numRestricted} with Controlled Substances access (${totalCost} per ${isAnnual ? 'year' : 'month'})`;
}